import {useMemo} from 'react'

import {areaDepartmentCodes} from '../consts'
import {mapDepartmentOptions} from '../mappers'
import {UpmEntityType} from '../types'
import {getSubNodesByUpmType} from '../utils'

import {useUpmStructure} from './useUpmStructure'

export const useKpiNodeIds = (
  plantId: string,
  availableAreaDepartmentCodes = areaDepartmentCodes,
  enabled = true
) => {
  const {data: structure} = useUpmStructure({plantId, options: {enabled}})

  return useMemo(() => {
    const allDepartments = structure
      ? getSubNodesByUpmType(structure, structure.upmId, UpmEntityType.Department)
      : []
    const availableDepartments = allDepartments.filter((equipment) =>
      availableAreaDepartmentCodes.some((code) => equipment.entityCodesPath?.includes(code))
    )

    return structure ? mapDepartmentOptions(availableDepartments) : []
  }, [structure, availableAreaDepartmentCodes])
}
